var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPsikiatriIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 21C12.3166 21 12.079 20.904 11.887 20.712C11.695 20.52 11.5993 20.2827 11.6 20V13.025C10.5333 13.025 9.50831 12.8207 8.52498 12.412C7.54164 12.0033 6.67498 11.4243 5.92498 10.675C5.17498 9.925 4.59998 9.05833 4.19998 8.075C3.79998 7.09167 3.59998 6.06667 3.59998 5V4C3.59998 3.71667 3.69598 3.47933 3.88798 3.288C4.07998 3.09667 4.31731 3.00067 4.59998 3H5.59998C6.64998 3 7.66664 3.20433 8.64998 3.613C9.63331 4.02167 10.5 4.60067 11.25 5.35C11.7666 5.86667 12.196 6.43333 12.538 7.05C12.88 7.66667 13.1423 8.325 13.325 9.025C13.4083 8.90833 13.5 8.79567 13.6 8.687C13.7 8.57833 13.8083 8.466 13.925 8.35C14.675 7.6 15.5416 7.02067 16.525 6.612C17.5083 6.20333 18.5333 5.99933 19.6 6H20.6C20.8833 6 21.121 6.096 21.313 6.288C21.505 6.48 21.6006 6.71733 21.6 7V8C21.6 9.06667 21.3956 10.0917 20.987 11.075C20.5783 12.0583 19.9993 12.925 19.25 13.675C18.5 14.425 17.6376 15 16.663 15.4C15.6883 15.8 14.6673 16 13.6 16V20C13.6 20.2833 13.504 20.521 13.312 20.713C13.12 20.905 12.8826 21.0007 12.6 21Z",
    fill: "#358888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsikiatriIcon);
export default __webpack_public_path__ + "static/media/psikiatri_icon.ad4a031d64a51c176e9bcfca82ffae8c.svg";
export { ForwardRef as ReactComponent };